import { Component, EventEmitter, Input,Output, OnDestroy, OnInit, NgZone } from '@angular/core';
import { LocusDetailsDto } from 'src/app/models/locus-details-dto';
import { BasketDto } from "../../models/basket-dto";
import { EntityType } from 'src/app/enums/entity-type.enum';
import { ApiService } from 'src/app/services/api.service';
import { RoutingService } from 'src/app/services/routing.service';
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { Entity, License } from 'src/app/models/mvp-query-response-dto';

import { ENTITY_MENU_CATEGORIES } from 'src/app/constants';
import { MenuItem } from 'primeng/api';
import { ScreenDimensionsService } from 'src/app/services/screen-dimensions.service';
import { MultiLangStrDto } from 'src/app/models/multi-lang-str-dto';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language.service';
import { ARCGIS_MAP_LIFECYCLE } from '../arcgis-map/constants/map-life-cycle.interface';
import { MainMapService } from '../arcgis-map/services/main-map.service';
import { ControlType } from '../arcgis-map/constants/control-type.enum';
import { MapControlItem } from '../arcgis-map/constants/map-control-item.interface';

@Component({
  selector: 'locus',
  templateUrl: './locus.component.html',
  styleUrls: ['./locus.component.scss'],
	providers: [
		{
			provide: ARCGIS_MAP_LIFECYCLE,
			useClass: MainMapService,
		},
	]
})
export class LocusComponent implements OnInit, OnDestroy {
  private entityDetailsSubscription?: Subscription;
  closeClicked: Subject<void> = new Subject<void>();
  @Output() onShapeLeftClick = new EventEmitter<any[]>();
  @Output() onClose = new EventEmitter<void>();
  menuCategories = ENTITY_MENU_CATEGORIES;
  selectedLocusDetails!: LocusDetailsDto;
  locusBasketList!: BasketDto[]
  basketGroups: any;
  locusDetailsIsLoading: boolean = true;
  basketListIsLoading: boolean = true;
  entityId: number = -1;
  entity: Entity = {} as Entity;
  entityType: string = EntityType.LOCUS;
  Array = Array;
  shapes: any[] = [];
  chafiraLicenses: License[] = [];
  zoomShapeIds: string[] =[];
  activeTab: MenuItem = this.menuCategories[0];
  tabIndex = 0;
  isSmallScreen = false;
  currentLanguage$!: Observable<string>;

  constructor(private screenDimensionsService: ScreenDimensionsService,
     private routingService: RoutingService,
     private apiService: ApiService,
     private translate: TranslateService,
     private languageService: LanguageService,
     private ngZone: NgZone) {
  }

  	mapControls: MapControlItem[] = [
		{ position: 'top-left', type: ControlType.FullScreen },
		{ position: 'top-left', type: ControlType.Zoom },
        		{
			position: 'top-left',
			type: ControlType.BasemapGallery,
			expand: {
				id: 'basemap-gallery-expand',
				position: 'top-left',
				expandIcon: 'basemap',
				expandTooltip: `${this.translate.instant('iaa.map.expand-basemap-gallery')}`,
				mode: 'floating',
			},
		},
	];

  ngOnInit(): void {
    this.currentLanguage$ = this.languageService.currentLanguage$;
    this.screenDimensionsService.isSmallScreen$.subscribe(isSmallScreen => {
      this.isSmallScreen = isSmallScreen;
    });

    this.entityDetailsSubscription = this.routingService.entityDetails$
      .subscribe(entityDetails => {
        this.ngZone.run(() => {
          const { id, type } = entityDetails;
          if (!!id && [EntityType.LOCUS, EntityType.BASKET].includes(type as EntityType)) {
            this.entityId = id;
            this.entityType = type;
            this.getLocusDetails(id, type);
          }
        });
      });
  }
  ngOnDestroy(): void {
    this.entityDetailsSubscription?.unsubscribe();
  }
  onActiveTabChange(event: MenuItem) {
    this.activeTab = event;
    this.tabIndex = this.menuCategories.findIndex((category) => category.label === event.label);
  }

  getDetailsTitle(): string {
    const licensesText = this.selectedLocusDetails?.locusLicenses?.length === 1 ? 'iaa.app.locus.inLicense' : 'iaa.app.locus.inLicenses';
    const licensesNames = this.selectedLocusDetails?.locusLicenses?.map(l => l.longName)?.join(', ') || '';

    return `${this.translate.instant('iaa.app.locus.locusNumber')} ${this.selectedLocusDetails?.locusName || ''} ${this.translate.instant(licensesText)} ${licensesNames || ''}`;
  }

  convertToConvertedShape(shape: any): any {
    const entity = shape.shapeData.entity;
    return {
      shapeId: shape.shapeId.toString(),
      wkt: shape.shapeWkt,
      layerName: "שכבת תוצאות שאילתה",
      hidden: false,
      isExtent: true,
      shapeData: {
        entity: {
          entityId: entity.entityId,
          entityType: entity.entityType
        },
      },
      styledParams: {
        geometryType: "Polygon", // Assuming default geometry type is Polygon
        fillColor: [0, 0, 0, 0],
        borderColor: [0, 0, 0, 0],
        borderWidth: 2,
      },
    };
  }
  handleLeftClick(shapes:any[]){
    this.entity = shapes[0].shapeData.entity;
    let url = ''
    this.routingService.navigateWithMerge({entityId:shapes[0].shapeData.entity.entityId,entityType:shapes[0].shapeData.entity.entityType}, [url || '']);
  }
  convertShapesArray(shapes: any[]): any[] {
    return shapes.map((shape) => this.convertToConvertedShape(shape));
  }
  getChafiraShapes() {
    let convertedShapesForChafiraLoci: any[] = this.convertShapesArray(this.selectedLocusDetails.mapInformation.chafiraLocusShapes);
    let convertedShapesForSurroundingLoci: any[] = this.convertShapesArray(this.selectedLocusDetails.mapInformation.surroundingLocusShapes);
    let convertedShapesForSelectedLocus: any[] = this.convertShapesArray(this.selectedLocusDetails.mapInformation.selectedLocusShapes);
    
    convertedShapesForSelectedLocus.forEach((shape: any) => {
        shape.styledParams.fillColor = [106, 90, 205, 0.5];
        shape.styledParams.borderColor = [106, 90, 205];
      });
      convertedShapesForChafiraLoci.forEach((shape: any) => {
        shape.styledParams.fillColor = [255, 180, 238, 0.5];
        shape.styledParams.borderColor = [255, 180, 238];
      });
      convertedShapesForSurroundingLoci.forEach((shape: any) => {
        shape.styledParams.fillColor = [255, 165, 0, 0.5];
        shape.styledParams.borderColor = [255, 165, 0];
      });
      this.shapes = this.shapes.concat(convertedShapesForChafiraLoci, convertedShapesForSurroundingLoci, convertedShapesForSelectedLocus);
      this.zoomShapeIds = [
        ...convertedShapesForSurroundingLoci.map(shape => shape.shapeId),
        ...convertedShapesForSelectedLocus.map(shape => shape.shapeId)
    ];    }

  getLocusDetails(entityId: number, entityType: string) {
    this.locusDetailsIsLoading = true;
    this.basketListIsLoading = true;
    this.apiService.getLocusDetails(entityId, entityType)
      .pipe(takeUntil(this.closeClicked))
      .subscribe({
        next: (res: LocusDetailsDto) => {
          this.selectedLocusDetails = res;
          this.locusBasketList = res.baskets;
          this.locusBasketList = this.locusBasketList.map(x => (x.basketId === entityId ? { ...x, isSelected: false } : x));
          this.basketGroups = this.createBasketGroups(res.baskets);
          this.stopLoading();
        },
        error: () => this.stopLoading(),
        complete: () => {
          this.stopLoading(); 
          if(this.locusBasketList?.length > 0) {
          }
          this.getChafiraShapes();

        }
      }
      );
  }

  stopLoading() {
    this.locusDetailsIsLoading = false;
    this.basketListIsLoading = false;
  }

  createBasketGroups(baskets: BasketDto[]) {
    if (baskets.length === 0) return [];
  
    // Separate baskets with and without basketType
    const validBaskets = baskets.filter((i: BasketDto) => i.basketType && i.basketType);
    const invalidBaskets = baskets.filter((i: BasketDto) => !i.basketType);
  

    const groupRes = groupByMultipleKeys(validBaskets,  [(i: BasketDto) => i.basketType.wordName.english]);
  
    const basketGroups = [{
      basketType: new MultiLangStrDto('הכל','All'),
      basketPeriod: '',
      baskets: baskets,
      isSelected: false
    }];
    Object.keys(groupRes).forEach(key => {
      let sp = key.split('_');
      const firstBasket = groupRes[key][0];
      const basketType = firstBasket.basketType.wordName;
      basketGroups.push({
        basketType: basketType,
        basketPeriod: sp[1],
        baskets: groupRes[key],
        isSelected: false
      });
    });
  
    if (invalidBaskets.length > 0) {
      basketGroups.push({
        basketType: new MultiLangStrDto('ללא סוג','No Type'), // This translates to 'No Type' in Hebrew
        basketPeriod: '',
        baskets: invalidBaskets,
        isSelected: false
      });
    }
    return basketGroups;
  }

  groupSelected($event: any) {
    this.locusBasketList = $event.baskets;
    this.basketGroups.forEach((group: any) => {
      group.isSelected = false;
      group.baskets.forEach((basket: any) => {
        basket.isSelected = false;
      })
    });
    this.basketGroups = [...this.basketGroups];
    let foundGroup = this.basketGroups.find((group: any) => group.basketType === $event.groupName);
    if (foundGroup) {
      foundGroup.isSelected = false;
      if(foundGroup.baskets.length > 0) {
        foundGroup.baskets[0].isSelected = false;
      }
    }
  }
}

const groupByMultipleKeys = <T>(arr: T[], keys: ((i: T) => any)[]) =>
  arr.reduce((groups, item) => {
    const groupKey = keys.map(key => key(item)).join('_');
    (groups[groupKey] ||= []).push(item);
    return groups;
  }, {} as Record<string, T[]>);